// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import slick from './routes/slick'; 
//import map from './routes/map';
import 'owl.carousel/dist/owl.carousel'; 

import 'jquery-lazy';
import 'slick-carousel/slick/slick';
import 'imagesloaded/imagesloaded';

import { Fancybox } from "@fancyapps/ui";
Fancybox.bind('[data-fancybox="gallery"]', { 
});

import 'aos/dist/aos';
import AOS from 'aos';
AOS.init();


/** Populate Router instance with DOM routes */
const routes = new Router({
    common, 
    slick,
    //map,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

import {config,  library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-free/js/all';

config.searchPseudoElements=true;
library.add(faFacebook, faTwitter, faCaretUp);
dom.watch();


// WEBPACK FOOTER //
// ./scripts/main.js